import {ChangeDetectionStrategy, Component, Input, NgZone, OnDestroy, OnInit, TemplateRef} from '@angular/core';

interface CarouselItem {
  img: string;
  title: string;
  desc: string;
}

@Component({
    selector: 'db-carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    standalone: false
})
export class CarouselComponent implements OnInit, OnDestroy {

  @Input() template: TemplateRef<any>;
  @Input() items: CarouselItem[];
  @Input() height: number;
  @Input() leftAlign?: boolean = false;
  @Input() navAdditionalClass?: string;
  @Input() withProgressBar?: boolean;
  public checked: number = 0;
  public percentageLeft: number = 0;
  private _interval: any;
  private _progressInterval: any;

  constructor(private _zone: NgZone) { }

  ngOnInit() {
    if (this.withProgressBar) {
      this._zone.runOutsideAngular(() => {
        // Start first progress immediately
        this._zone.run(() => this.startProgress());

        // Then repeat every 12 seconds
        this._interval = setInterval(() => {
          this._zone.run(() => this.startProgress());
        }, 10000);
      });
    }
    else this.startAutoAnimation();
  }

  startAutoAnimation(): void {
    this._zone.runOutsideAngular(() => {
      this._interval = setInterval(() => {
        this.checked = this.items[this.checked + 1] ? this.checked + 1 : 0;
      }, 10000);
    });
  }

  startProgress() {
    this.percentageLeft = 0;

    if (this._progressInterval) {
      clearInterval(this._progressInterval);
    }

    this._progressInterval = setInterval(() => {
      if (this.percentageLeft < 98) {
        this.percentageLeft += 1;
      } else {
        clearInterval(this._progressInterval);
        this.checked = this.items[this.checked + 1] ? this.checked + 1 : 0;
        this.percentageLeft = 0;
      }
    }, 100);
  }

  ngOnDestroy() {
    clearInterval(this._interval);
  }

}
